import { render, staticRenderFns } from "./orderThrough.vue?vue&type=template&id=f6a5a476&scoped=true"
import script from "./orderThrough.vue?vue&type=script&lang=js"
export * from "./orderThrough.vue?vue&type=script&lang=js"
import style0 from "./orderThrough.vue?vue&type=style&index=0&id=f6a5a476&prod&lang=css"
import style1 from "./orderThrough.vue?vue&type=style&index=1&id=f6a5a476&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a5a476",
  null
  
)

export default component.exports